//  npm install react-chartjs-2 chart.js

import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Rejestracja komponentów Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function WeatherReport() {
  const [jsonData, setJsonData] = useState(null);    // dane pogodowe w formacie json
  const [loading, setLoading] = useState(true);      // wskaźnik ładowania strony 
  const [data1, setData1] = useState(null);          // dane pogodowe na wykresie   

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          'https://api.open-meteo.com/v1/forecast?latitude=51.7551091&longitude=19.4465375&hourly=temperature_2m&timezone=Europe%2FBerlin&forecast_days=7'
        );
        const result = await response.json();
        setJsonData(result);
        setLoading(false);
      } catch (error) {
        console.error('Błąd podczas pobierania danych:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (jsonData) {
      const labels = jsonData.hourly.time;
      const temperatures = jsonData.hourly.temperature_2m;

      setData1({
        labels: labels,
        datasets: [
          {
            label: 'Temperatura (°C)',
            data: temperatures,
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderWidth: 1,
            fill: true
          }
        ]
      });
    }
  }, [jsonData]); // useEffect uruchamia się tylko wtedy, gdy jsonData się zmienia

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      {/*<h2>dane pogodowe w formacie json</h2>
      <pre>{JSON.stringify(jsonData, null, 2)}</pre>*/}
      {data1 && (
        <>
          <h1>Prognoza Pogody na tydzień - Temperatura</h1>
          <Line data={data1} options={{ responsive: true }} />
        </>
      )}
    </div>
  );
}


